import React from 'react';
import { PictureProps } from '../../../types/components';

export default function Picture({
  image,
  classes,
  pictureClasses,
  loading,
}: PictureProps) {
  const media = {
    all: '',
    xs: '(max-width: 389px)',
    sm: '(max-width: 599px)',
    md: '(max-width: 767px)',
    lg: '(max-width: 1023px)',
    'lg-min': '(min-width: 1024px)',
    xl: '(max-width: 1199px)',
    'xl-min': '(min-width: 1200px)',
    '2xl': '(max-width: 1439px)',
    '2xl-min': '(min-width: 1440px)',
    '3xl': '(max-width: 1549px)',
    '3xl-min': '(min-width: 1550px)',
    '4k': '(min-width: 3840px)',
    '5xl': '(min-width: 2560px)',
    '4xl': '(min-width: 1919px)',
  };

  if (typeof image !== 'string') {
    const {
      url,
      alt,
      extension,
      transforms,
      defaultTransform,
    } = image;
    if (extension !== 'svg') {
      return (
        <picture className={pictureClasses}>
          {Object.keys(media).map((key) => {
            if (key !== 'all' && transforms[key]) {
              return (
                <source
                  key={key}
                  media={media[key as keyof typeof media]}
                  srcSet={transforms[key]?.url}
                />
              );
            }
            return null;
          })}
          <img
            src={transforms[defaultTransform]?.url}
            alt={alt}
            loading={loading}
            width={transforms[defaultTransform]?.width}
            height={transforms[defaultTransform]?.height}
            className={classes}
          />
        </picture>
      );
    }
    return (
      <img src={url} alt={alt} className={classes} />
    );
  }
  return <img src={image} alt="" className={classes} />;
}
